import { isCountryLevel } from "./routes";
import { byCzechName } from "./utils/czechSort";

/**
 * Čisté pomocníky editorů adminu (vize F9.2 a F9.5, řez 09):
 * - `resolveEditorTab` určí aktivní záložku editoru z parametru adresy `?tab=` (čte ho hook
 *   `useEditorTab` v adminu); chybějící, neznámé nebo skryté id = první viditelná záložka;
 * - `parentDestinationOptions` dá volby roletky „Nadřazená destinace": všechny destinace na
 *   úrovni země (`isCountryLevel`, jediný predikát) kromě editované, dnešní rodič zůstane
 *   mezi volbami vždy; řazení podle české kolace názvu (`byCzechName`).
 *
 * Bydlí v `packages/shared`, protože admin nemá vlastní testovací runtime (precedent
 * `linkPickerItems`). Signatury jsou Kontrakt řezu 09 (bod 5); těla a test píše část K2.
 */

/** Id aktivní záložky: platné id viditelné záložky, jinak první viditelná záložka. */
export function resolveEditorTab(param: string | null, visibleTabIds: readonly string[]): string {
  // Žádná normalizace (velikost písmen, mezery): adresu píše jen editor sám.
  if (param !== null && visibleTabIds.includes(param)) return param;
  return visibleTabIds[0] ?? "";
}

/** Volby roletky nadřazené destinace (úroveň země bez editované, dnešní rodič vždy). */
export function parentDestinationOptions<
  T extends { id: string; name: string; parentId?: string | null; showAsCountry?: boolean | null },
>(rows: readonly T[], selfId: string | null, currentParentId: string | null): T[] {
  // Dnešní rodič zůstává vždy, i když podmínku nesplňuje (nekonzistentní data): jinak by
  // `<select>` volbu neměl a redaktor by viděl jinou hodnotu, než jaká se uloží. Potomky
  // editované destinace nevylučujeme — takovou volbu odmítne API (`assertValidParent`).
  return rows
    .filter(
      (row) =>
        (currentParentId !== null && row.id === currentParentId) ||
        (row.id !== selfId && isCountryLevel(row)),
    )
    .sort(byCzechName);
}
